import { JSX } from "react";

import { cn } from "@/utils/cn.ts";

interface MovieCardSkeletonProps {
  className?: string;
}

const MovieCardSkeleton = ({ className }: MovieCardSkeletonProps): JSX.Element => {
  return (
    <div
      className={cn(
        "bg-surface-container aspect-video h-auto w-full animate-pulse rounded-[1.25rem] max-lg:rounded-[0.625rem] ",
        className,
      )}
    />
  );
};

export default MovieCardSkeleton;
